import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import List from "../Components/Po Invert/List";
import Add from "../Components/Po Invert/Add";
import View from "../Components/Po Invert/View";
import InstallationCertification from "../Components/Installation Certificate Ui/MainInstallationCertification";
import { useSelector } from "react-redux";
import * as utils from "../Utils/comman";

function Invert() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const [invertId,setInvertId]=useState('')
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
            setInvertId={setInvertId}

          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;

      case "installation":
        return (
          <InstallationCertification
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            invertId={invertId}
          />
        );
      default:
        return (
          <Add
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            currentOrder={currentOrder}
          />
        );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>
              {utils.hasPermission(
                primaryMenuRes,
                "Invert",
                "invert.list_for_installation"
              )
                ? "Capital Invert"
                : "Invert"} 
              
            </h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default Invert;
